function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3712",
  "data-name": "Group 3712",
  transform: "translate(-539 -422)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3321",
  "data-name": "Group 3321",
  transform: "translate(-4 -77)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(543 499)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_22_Copy",
  "data-name": "Group 22 Copy"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bg",
  width: 24,
  height: 24,
  rx: 12,
  fill: "#7d9ef1"
})))), /*#__PURE__*/React.createElement("path", {
  id: "drafts_FILL1_wght400_GRAD0_opsz48",
  d: "M4.924,14.66A.947.947,0,0,1,4,13.737V6.61a1.208,1.208,0,0,1,.1-.469.769.769,0,0,1,.346-.377L9.68,2.623a.577.577,0,0,1,.231-.1,1.325,1.325,0,0,1,.493,0,.577.577,0,0,1,.231.1l5.233,3.14a.72.72,0,0,1,.354.377,1.294,1.294,0,0,1,.092.469v7.127a.947.947,0,0,1-.924.924Zm5.233-5.218a.419.419,0,0,0,.115-.015.676.676,0,0,0,.115-.046l4.941-2.894L10.388,3.516a.676.676,0,0,0-.115-.046.441.441,0,0,0-.231,0,.676.676,0,0,0-.115.046L4.985,6.487,9.926,9.38a.676.676,0,0,0,.115.046.419.419,0,0,0,.115.015Z",
  transform: "translate(540.843 425.42)",
  fill: "#7d9ef1"
}));

var SvgEmailOpenState = function SvgEmailOpenState(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailOpenState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-open-state.08790e06.svg";
export { ForwardRef as ReactComponent };